"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FacetFilterHeader = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FacetFilterHeader = (param)=>{
    let { amountSelected, amountTotal, isOpen, title, onClick, showArrow = true, showAmount = true, showAmountTotal = true, isFirst = false } = param;
    const canShowTotalAmount = showAmountTotal && amountTotal !== undefined;
    const { getTestId } = (0, _testidGenerator.default)();
    const titleText = canShowTotalAmount ? "".concat(title, " (").concat(amountTotal, ")") : title;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.FACET_FILTER_HEADER),
        isFirst: isFirst,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.TitleLayout, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                            "data-testid": getTestId(_constants.FACET_FILTER_HEADER_TITLE),
                            children: titleText
                        })
                    }),
                    showAmount && Boolean(amountSelected) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Badge, {
                        "data-testid": getTestId(_constants.FACET_FILTER_BADGE),
                        color: "primary",
                        badgeContent: amountSelected,
                        max: 99
                    }) : null
                ]
            }),
            showArrow ? isOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.ArrowUpThin, {
                "data-testid": getTestId(_constants.ARROW_UP_ICON)
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
                "data-testid": getTestId(_constants.ARROW_DOWN_ICON)
            }) : null
        ]
    });
};
exports.FacetFilterHeader = FacetFilterHeader;
